"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeatEconom = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SeatEconom = function SeatEconom(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.655 3.762A1.88 1.88 0 104.654.001a1.88 1.88 0 000 3.761zm-2.921 7.397L0 3.135h1.924l1.648 7.626a3.447 3.447 0 003.37 2.72h3.98v1.881h-3.98a5.328 5.328 0 01-5.208-4.203z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.046 7.945l.505 2.4h3.41L16 14.726 14.618 16l-3.48-3.773H7.433a2.82 2.82 0 01-2.76-2.24l-.706-3.354a1.86 1.86 0 013.516-1.149l.499.5a3.093 3.093 0 003.037.787l.43 1.507a4.659 4.659 0 01-3.404-.333z",
    fill: "currentColor"
  }));
};

exports.SeatEconom = SeatEconom;
var _default = SeatEconom;
exports.default = _default;